import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollAppToTop } from "../utils/scrollAppToTop";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    scrollAppToTop("auto");
    const frame = requestAnimationFrame(() => scrollAppToTop("auto"));
    return () => cancelAnimationFrame(frame);
  }, [pathname]);

  return null;
}
